module.exports = __webpack_public_path__ + "img/Funds Granted Flow Chart.398c670b.svg";